import { render, staticRenderFns } from "./ChangeSecurityQuestion.vue?vue&type=template&id=2f68e8b9&scoped=true&"
import script from "./ChangeSecurityQuestion.vue?vue&type=script&lang=js&"
export * from "./ChangeSecurityQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f68e8b9",
  null
  
)

export default component.exports